import { useEffect, useState } from 'react';
import { inventarioService, productosService } from '../../services/api';
import { chip, pesos } from '../../components/ui/estilos';
import { entrada } from '../agenda/campos';
import RecetaProducto from '../menu/RecetaProducto';
import { num } from './insumos';

// Recetas desde Almacén: cocina no entra a Menú › Productos, pero sí arma las recetas.
export function Recetas({ say }: { say: (m: string) => void }) {
  const [productos, setProductos] = useState<any[]>([]);
  const [busca, setBusca] = useState('');
  const [sel, setSel] = useState<any>(null);
  useEffect(() => { productosService.getAll().then(r => setProductos(r.data.filter((p: any) => !p.suspendido))).catch(() => say('No se pudo cargar el menú.')); }, [say]);
  const q = busca.trim().toLowerCase();
  const visibles = productos.filter(p => !q || p.nombre.toLowerCase().includes(q));

  return (
    <div className="paneles" style={{ height: '100%', display: 'grid', gridTemplateColumns: 'minmax(240px,1fr) clamp(320px,40%,480px)' }}>
      <section aria-label="Productos" style={{ minHeight: 0, overflowY: 'auto', padding: '18px 22px', display: 'flex', flexDirection: 'column', gap: 10 }}>
        <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar producto…" aria-label="Buscar producto" style={{ ...entrada, borderRadius: 12 }} />
        {visibles.map(p => (
          <button key={p.id} onClick={() => setSel(p)} aria-pressed={sel?.id === p.id} style={{ minHeight: 52, padding: '0 16px', borderRadius: 12, cursor: 'pointer', textAlign: 'left', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, color: 'var(--ink)', fontSize: 15,
            border: sel?.id === p.id ? '2px solid var(--brand-texto)' : '1px solid var(--line)', background: sel?.id === p.id ? 'var(--well)' : 'var(--surface)' }}>
            <b>{p.nombre}</b><span style={{ fontSize: 13, color: 'var(--muted)' }}>{p.categoria}</span>
          </button>
        ))}
        {!visibles.length && <div style={{ padding: 30, textAlign: 'center', color: 'var(--muted)' }}>Sin productos.</div>}
      </section>
      <aside aria-label="Receta" style={{ borderLeft: '1px solid var(--line)', background: 'var(--surface)', minHeight: 0, overflowY: 'auto', padding: 20, display: 'flex', flexDirection: 'column', gap: 12 }}>
        {sel
          ? <><h2 style={{ margin: 0, fontSize: 22 }}>{sel.nombre}</h2><RecetaProducto key={sel.id} producto={sel} say={say} /></>
          : <div style={{ flex: 1, display: 'grid', placeItems: 'center', textAlign: 'center', color: 'var(--muted)', fontSize: 16 }}>Elige un producto para armar su receta.</div>}
      </aside>
    </div>
  );
}

const color = (m: number) => m >= 60 ? chip('var(--ok-bg)', 'var(--ok)') : m >= 30 ? chip('var(--warn-bg)', 'var(--warn)') : chip('var(--danger-bg)', 'var(--danger)');
const fila: React.CSSProperties = { display: 'grid', gridTemplateColumns: 'minmax(0,1fr) 100px 100px 100px 80px', gap: 10, alignItems: 'center', padding: '12px 16px', fontSize: 15 };

export function Costos() {
  const [costos, setCostos] = useState<any[]>([]);
  const [cat, setCat] = useState('');
  const [error, setError] = useState(false);
  useEffect(() => { inventarioService.getCostos().then(r => setCostos(r.data)).catch(() => setError(true)); }, []);
  const cats = [...new Set(costos.map(p => p.categoria).filter(Boolean))].sort();
  const visibles = costos.filter(p => !cat || p.categoria === cat);

  return (
    <div style={{ height: '100%', overflowY: 'auto', padding: '18px 22px', display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ fontSize: 15, color: 'var(--muted)' }}>Costo según la receta y cuánto queda de cada venta.</div>
        {cats.length > 1 && (
          <select value={cat} onChange={e => setCat(e.target.value)} aria-label="Categoría" style={{ ...entrada, width: 220 }}>
            <option value="">Todas las categorías</option>
            {cats.map(c => <option key={c}>{c}</option>)}
          </select>
        )}
      </div>
      <div role="table" style={{ borderRadius: 14, border: '1px solid var(--line)', background: 'var(--surface)', overflowX: 'auto' }}>
        <div role="row" style={{ ...fila, minWidth: 560, fontSize: 12, fontWeight: 700, color: 'var(--muted)', background: 'var(--well)' }}>
          <span>PRODUCTO</span><span style={{ textAlign: 'right' }}>PRECIO</span><span style={{ textAlign: 'right' }}>COSTO</span><span style={{ textAlign: 'right' }}>UTILIDAD</span><span style={{ textAlign: 'right' }}>MARGEN</span>
        </div>
        {error && <div role="alert" style={{ padding: 30, textAlign: 'center', color: 'var(--danger)' }}>No se pudieron cargar los costos.</div>}
        {!error && !visibles.length && <div style={{ padding: 30, textAlign: 'center', color: 'var(--muted)' }}>Arma recetas para ver costos y márgenes.</div>}
        {visibles.map(p => {
          const costo = num(p.costo_receta);
          return (
            <div key={p.id} role="row" style={{ ...fila, minWidth: 560, borderTop: '1px solid var(--line)' }}>
              <span style={{ minWidth: 0 }}><b>{p.nombre}</b><span style={{ display: 'block', fontSize: 13, color: 'var(--muted)' }}>{p.categoria}</span></span>
              <span style={{ textAlign: 'right' }}>{pesos(num(p.precio))}</span>
              <span style={{ textAlign: 'right', color: 'var(--muted)' }}>{costo > 0 ? pesos(costo) : 'Sin receta'}</span>
              <span style={{ textAlign: 'right', fontWeight: 700 }}>{pesos(num(p.utilidad))}</span>
              <span style={{ textAlign: 'right' }}>{costo > 0 ? <span style={{ ...color(num(p.margen_pct)), fontSize: 13 }}>{Math.round(num(p.margen_pct))}%</span> : <span style={{ color: 'var(--muted)' }}>—</span>}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
